export const BASE_URL_BETA = process.env.REACT_APP_BASE_URL || "https://api.farmacare.dev/production"